import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BrightsideUiModule, HeaderLabelCellConfig } from '@brightside/brightside-ui';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'brightside-web-payroll-complete-card',
    templateUrl: './payroll-complete-card.component.html',
    styleUrl: './payroll-complete-card.component.scss',
    imports: [BrightsideUiModule, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('fadeIn', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('500ms ease-out', style({ opacity: 1 }))
            ])
        ])
    ]
})
export class PayrollCompleteCardComponent {
  private _translateService: TranslateService = inject(TranslateService);

  payrollCompleteCellConfig : HeaderLabelCellConfig = {
    leftTitle:  this._translateService.instant('PAYROLL_RESOLVED_TITLE'),
    leftSubtitle : this._translateService.instant('PAYROLL_RESOLVED_DESC'),
    leftTitleSemibold: true,
    leftContentFullWidth: true,
    rightIconName: 'checkmark',
    rightIconColor: 'var(--green-50)',
    bgColor: 'var(--green-5)',
    minHeight: '2.2rem'
  }
}
